import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Play } from "lucide-react";
import { fadeUp, viewportOnce } from "../lib/motion";
import { IMG_STONE_DUSK } from "../lib/product";
import { WireframeHouse } from "./product/shared";
import { trackEvent } from "../lib/seo";

const ClosingCta = () => (
    <section
        data-testid="closing-cta-section"
        className="relative overflow-hidden bg-abyss py-28 lg:py-40"
    >
        <div className="relative mx-auto grid max-w-[1600px] items-center gap-16 px-6 md:px-10 lg:grid-cols-2 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
            >
                <p className="font-mono text-[13px] tracking-[0.3em] text-mist">
                    NEXT STEP
                </p>
                <h2
                    data-testid="closing-headline"
                    className="mt-6 font-display text-4xl font-semibold leading-[1.08] tracking-tight text-white md:text-6xl"
                >
                    Your home-building journey deserves greater clarity.
                </h2>
                <p className="mt-6 max-w-md text-[16px] leading-relaxed text-mist">
                    BuildEase helps you understand what comes next — before
                    construction begins.
                </p>
                <div className="mt-10 flex flex-wrap items-center gap-4">
                    <Link
                        to="/join-the-pilot"
                        data-testid="closing-get-started"
                        onClick={() => trackEvent("get_started_click", "closing_cta")}
                        className="group inline-flex items-center gap-2 bg-accent px-7 py-4 text-[16px] font-semibold text-white transition-colors duration-300 hover:bg-[#ff7026]"
                    >
                        Get Started with BuildEase
                        <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
                    </Link>
                    <Link
                        to="/how-it-works"
                        data-testid="closing-how-it-works"
                        className="inline-flex items-center gap-2.5 text-[15px] font-medium text-white transition-colors duration-300 hover:text-accent"
                    >
                        <Play className="h-3.5 w-3.5" />
                        See How It Works
                    </Link>
                </div>
            </motion.div>

            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                data-testid="closing-visual"
                className="relative hidden h-[420px] lg:block"
            >
                <img
                    src={IMG_STONE_DUSK}
                    alt="Realistic evening view of a contemporary home"
                    loading="lazy"
                    className="absolute right-0 top-1/2 h-[85%] w-[78%] -translate-y-1/2 object-cover"
                    style={{
                        maskImage:
                            "linear-gradient(to right, transparent 0%, black 45%)",
                        WebkitMaskImage:
                            "linear-gradient(to right, transparent 0%, black 45%)",
                    }}
                />
                <WireframeHouse className="absolute left-0 top-1/2 w-[68%] -translate-y-1/2 text-white/35" />
                <span className="absolute bottom-2 left-2 font-mono text-[13px] tracking-[0.22em] text-cad">
                    FIG. F.01 — PLAN TO BUILD
                </span>
            </motion.div>
        </div>
    </section>
);

export default ClosingCta;
